<template>
  <div :state="sendPickup" class="pickup">
    <div class="pickup__card">
      <h6 style="color: #4caf50">
        <b><i class="pi pi-map-marker"></i> Pickup</b>
      </h6>
      <hr />
      <div class="pickup__cities">
        <b-form-input
          v-model="pickupAndDelivery.zip_from"
          placeholder="Zip from"
          size="sm"
          list="zip_from"
          class="pickup__cities--input"
          autocomplete="off"
        ></b-form-input>
        <div class="pickup__city-state">
          <b-form-input
            v-model="pickupAndDelivery.city_from"
            placeholder="City from"
            size="sm"
            list="city_from"
            class="pickup__city"
            autocomplete="off"
          ></b-form-input>
          <b-form-input
            v-model="pickupAndDelivery.state_from"
            placeholder="State from"
            size="sm"
            class="pickup__state"
            list="state_from"
            autocomplete="off"
          ></b-form-input>
        </div>
      </div>
      <hr />
      <div class="pickup__checkbox-container">
        <b-form-checkbox
          v-for="(accessorial, index) in accessorialsPickup"
          :key="accessorial.id"
          v-model="acceptedAccessorials[index]"
          value="accepted"
          @input="selectAccessorial(accessorial, index)"
          unchecked-value="not_accepted"
          size="sm"
          class="pickup__checkbox"
        >
          {{ accessorial.accessorial_name }}
        </b-form-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pickup",
  props: {
    sendAccessorialsPickup: Array,
  },
  data() {
    return {
      pickupAndDelivery: {
        zip_from: "",
        city_from: "",
        state_from: "",
        accessorials: [],
      },
      accessorialsPickup: [],
      acceptedAccessorials: [],
    };
  },
  created() {
    this.accessorialsPickup = this.sendAccessorialsPickup;
  },
  computed: {
    sendPickup() {
      return this.$emit("input", this.pickupAndDelivery);
    },
  },
  methods: {
    selectAccessorial(accessorial, index) {
      if (this.acceptedAccessorials[index] === "accepted") {
        this.pickupAndDelivery.accessorials.push(accessorial);
      }
      for (let i = 0; i < this.pickupAndDelivery.accessorials.length; i += 1) {
        if (
          this.pickupAndDelivery.accessorials[i].accessorial_name === accessorial.accessorial_name
          && this.acceptedAccessorials[index] === "not_accepted"
        ) {
          this.pickupAndDelivery.accessorials.splice(i, 1);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pickup {
  @include card;
  &__city-state {
    width: 50%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  }
  &__city,
  &__state {
    width: 120px;
    margin: 6px;
  }
  &__checkbox-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  &__checkbox {
    padding: 0 1rem;
  }
}
hr {
  margin: 8px 0px;
}
</style>
